module.exports = __webpack_public_path__ + "static/media/Assets-04-AB-dental-01.f561d11e.png";